import capitalizeFirstLetter from "./capitalizeFirstLetter";

export const translateProductName = (name) => {
  let lang = localStorage.getItem('preferred-language');

  if (typeof name !== 'string') return name;

  const translations = [
    { vi: "dây chuyền", en: "Necklace" },
    { vi: "nhẫn", en: "Ring" },
    { vi: "vòng tay", en: "Bracelet" },
    { vi: "bông tai", en: "Earring" }
  ];

  let translatedName = name;

  translations.forEach(({ vi, en }) => {
    if (lang === "en") {
      // Việt → Anh
      const viRegex = new RegExp(`\\b${vi}\\b`, "gi");
      translatedName = translatedName.replace(viRegex, en);
    } else if (lang === "vi") {
      // Anh → Việt
      const enRegex = new RegExp(`\\b${en}\\b`, "gi");
      translatedName = translatedName.replace(enRegex, vi);
    }
  });

  // Viết hoa chữ cái đầu
  translatedName = capitalizeFirstLetter(translatedName);

  return translatedName;
};

